/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import PropTypes from "prop-types";
import { toEnglishNum } from "utils/helpers";
import "./mandatoryEditableCell.scss";

const MandatoryEditableCell = ({ item, handleLogChange, withoutMin }) => {
    const initial = withoutMin ? item?.defaultValue : item.defaultValue || 0;
    const [inputValue, setInputValue] = useState(initial);
    const [min, setMin] = useState(0);
    const input = {
        name: item.good_id,
    };

    const handleInputChange = (name, value) => {
        setInputValue(value);
        handleLogChange(name, value);
        handleLogChange(
            name,
            toEnglishNum(value) && toEnglishNum(value).length > 0
                ? toEnglishNum(value)
                : value
        );
    };

    useEffect(() => {
        setInputValue(item.defaultValue);
        handleLogChange(input.name, item.defaultValue);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [item.defaultValue]);

    return (
        <Form.Control
            className={`mandatory-editable-input ${item.id === 0 ? "isBrown" : ""}`}
            type="number"
            min={min}
            name={input.name}
            value={inputValue}
            onChange={(event) =>
                handleInputChange(
                    input.name,
                    event.target.value ? Number(event.target.value) : null
                )
            }
        />
    );
};

MandatoryEditableCell.propTypes = {
    item: PropTypes.object,
    handleLogChange: PropTypes.func,
};

export default MandatoryEditableCell;
